// @ts-nocheck
// Header progress bar for the Create-from-PDF overlay.
// Steps: Type → Upload → Extract → Review → Link (CMS-1500) | Attach (EOB).
// Uses --ab-* tokens and shared Icon only — no MUI, no raw hex.
import { Icon } from '../shared';

const ORDER = ['choose', 'upload', 'processing', 'review', 'link'];
const EOB_ORDER = ['choose', 'upload', 'processing', 'review', 'attach'];
const LABELS = {
  choose: 'Type',
  upload: 'Upload',
  processing: 'Extract',
  review: 'Review',
  link: 'Link',
  attach: 'Attach',
};

export default function FlowSteps({ stage, docKind }) {
  const order = docKind === 'eob' ? EOB_ORDER : ORDER;
  const idx = Math.max(0, order.indexOf(stage));

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        fontFamily: 'var(--ab-font-sans)',
      }}
    >
      {order.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        return (
          <span key={s} style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              {/* Numbered / checked circle */}
              <span
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  flexShrink: 0,
                  border: `1.5px solid ${done || active ? 'var(--ab-fg)' : 'var(--ab-border-hair)'}`,
                  background: done ? 'var(--ab-fg)' : 'var(--ab-bg)',
                  color: done
                    ? 'var(--ab-fg-inverse)'
                    : active
                    ? 'var(--ab-fg)'
                    : 'var(--ab-fg-subtle)',
                  display: 'grid',
                  placeItems: 'center',
                  fontSize: 11,
                  fontWeight: 800,
                  lineHeight: 1,
                }}
              >
                {done ? <Icon name="check" size={11} /> : i + 1}
              </span>
              {/* Step label */}
              <span
                style={{
                  fontSize: 12,
                  fontWeight: active ? 700 : 500,
                  color: active ? 'var(--ab-fg)' : 'var(--ab-fg-subtle)',
                  whiteSpace: 'nowrap',
                }}
              >
                {LABELS[s]}
              </span>
            </span>
            {/* Connector line between steps */}
            {i < order.length - 1 && (
              <span
                style={{
                  display: 'inline-block',
                  width: 22,
                  height: 1,
                  background: done ? 'var(--ab-fg)' : 'var(--ab-border-hair)',
                  margin: '0 8px',
                  flexShrink: 0,
                }}
              />
            )}
          </span>
        );
      })}
    </div>
  );
}
